import { render, staticRenderFns } from "./ConfirmacaoDados.vue?vue&type=template&id=0d83b61e"
import script from "./ConfirmacaoDados.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports